import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=47ed3d9e&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=47ed3d9e&prod&lang=scss&scoped=true&"
import style1 from "./admin.vue?vue&type=style&index=1&id=47ed3d9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed3d9e",
  null
  
)

export default component.exports